import { useUnits } from '@geovelo-frontends/commons';
import { Box, Card, CardHeader, Grid as MuiGrid, Skeleton, Typography } from '@mui/material';
import { deepOrange, green, orange } from '@mui/material/colors';
import { useContext } from 'react';
import { Trans } from 'react-i18next';

import { AppContext } from '../../app/context';
import { environment } from '../../environment';

import facilities from './facilities';

function Grid(): React.JSX.Element {
  const {
    zone: { current: currentZone },
    stats: { byZone, periods, selectedKey, selectedIndex },
  } = useContext(AppContext);
  const { toDistance } = useUnits();

  const zoneStats = (currentZone && byZone[currentZone.id]) || [];
  const stats = zoneStats.find(({ dateAsKey }) => dateAsKey === selectedKey) || null;
  const prevKey = (periods && selectedIndex !== null && periods[selectedIndex - 1]?.key) || null;

  return (
    <Box padding={2}>
      <MuiGrid container spacing={2} sx={{ width: '100%' }}>
        {facilities.map(({ key, Icon, titleKey }) => {
          const distance = stats ? stats.distances[key] * 1000 : null;
          const prevStats =
            (prevKey && zoneStats.find(({ dateAsKey }) => dateAsKey === prevKey)) || null;
          const diff =
            (distance && prevStats && distance - prevStats.distances[key] * 1000) || null;
          // const tmpDistance = stats ? Math.round(stats.tmpDistances[key]) : null;
          const tmpDistance = 0;

          return (
            <MuiGrid key={key} size={6}>
              <Card
                className={key === 'all' ? 'total' : ''}
                sx={({ palette: { primary } }) => ({
                  height: 'calc(100% - 2px)',
                  minHeight: environment.enableTmpFacilities ? 112 : 92,
                  ...(key === 'all'
                    ? {
                        border: `1px solid ${primary.main}`,
                      }
                    : {}),
                })}
                variant="outlined"
              >
                <CardHeader
                  avatar={Icon && <Icon color="primary" />}
                  subheader={
                    stats ? (
                      <>
                        <Typography
                          component="span"
                          style={{
                            color: 'rgba(0, 0, 0, 0.87)',
                            display: 'inline-block',
                            fontSize: '1.1rem',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {toDistance(distance, true, 'km')}
                          &nbsp;
                        </Typography>
                        <Typography
                          color={diff && diff >= 0 ? green[500] : deepOrange[500]}
                          variant="caption"
                          whiteSpace="nowrap"
                        >
                          {diff && (
                            <>
                              ({diff > 0 ? '+' : '-'}
                              {toDistance(Math.abs(diff), true, 'km')})
                            </>
                          )}
                        </Typography>
                        {environment.enableTmpFacilities && key !== 'all' && tmpDistance ? (
                          <>
                            <br />
                            <Typography color={orange[500]} variant="caption">
                              <Trans
                                count={tmpDistance}
                                i18nKey="bicycle_facilities.stats.facilities.tmp_distance"
                                values={{ count: tmpDistance }}
                              />
                            </Typography>
                          </>
                        ) : (
                          <></>
                        )}
                      </>
                    ) : (
                      <Typography component="div" style={{ fontSize: '1.1rem' }}>
                        <Skeleton variant="text" width={100} />
                      </Typography>
                    )
                  }
                  title={
                    <Typography color="textSecondary" variant="caption">
                      <Trans i18nKey={titleKey} />
                    </Typography>
                  }
                />
              </Card>
            </MuiGrid>
          );
        })}
      </MuiGrid>
    </Box>
  );
}

export default Grid;
